"use client";

import { Image } from "@/components/Image";
import Section from "@/components/ui/Section";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { buttonKey } from "@/lib/list-keys";
import { TinaMarkdown, tinaField } from "@/lib/utils";
import Link from "next/link";

function CtaBody({ tinaFieldData, text, textField = "text" }) {
  if (!text) {
    return null;
  }

  const fieldBinding = tinaFieldData ? { "data-tina-field": tinaField(tinaFieldData, textField) } : {};

  if (typeof text === "string") {
    return (
      <p {...fieldBinding} className="text-base leading-relaxed text-muted-foreground md:text-lg">
        {text}
      </p>
    );
  }

  return (
    <div {...fieldBinding} className="prose">
      <TinaMarkdown content={text} />
    </div>
  );
}

export default function CallToAction({ tinaFieldData, title, text, textField = "text", image, buttons }) {
  return (
    <Section wrapperClassName="">
      <Card className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 bg-muted !p-4 lg:!p-12">
        <div className="flex flex-col gap-4 lg:pt-8 order-2 lg:order-1">
          {title && (
            <h2 data-tina-field={tinaField(tinaFieldData, "title")} className="h1 text-title text-balance flex-1">
              {title}
            </h2>
          )}
          <CtaBody tinaFieldData={tinaFieldData} text={text} textField={textField} />
          {buttons?.length > 0 && (
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              {buttons.map((btn, index) => (
                <Button
                  key={buttonKey(btn, index)}
                  data-tina-field={tinaField(buttons[index], "label")}
                  asChild
                  size="lg"
                  variant={index === 0 ? "default" : "outline"}
                  className="w-full sm:w-auto"
                  arrow={index === 0}
                >
                  <Link href={btn.link || "/"}>{btn.label}</Link>
                </Button>
              ))}
            </div>
          )}
        </div>
        {image && (
          <Image
            src={image}
            alt={title || ""}
            wrapperClassName="aspect-4/3 max-lg:max-h-[300px] w-full order-1 lg:order-2"
            className="object-cover rounded-lg object-center"
            data-tina-field={tinaField(tinaFieldData, "image")}
            sizes="(min-width: 1024px) 50vw, 100vw"
          />
        )}
      </Card>
    </Section>
  );
}
